import fortyufortyImg from "../../../../assets/40u40.png";
import * as React from 'react';
export default {
  fortyufortyImg,
  React
};